/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.mat-progress-bar[_ngcontent-%COMP%]   .mat-progress-bar-fill[_ngcontent-%COMP%]{transition:-webkit-transform 130ms ease;transition:transform 130ms ease;transition:transform 130ms ease,-webkit-transform 130ms ease}"];
export { styles as styles };
